import React from 'react';
import { Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FeatureCard from '../FeatureCard/FeatureCard';
import styles from './LandingPageLayout.module.css';

/**
 * LandingPageLayout - A reusable landing page layout component
 * 
 * @param {Object} props Component props
 * @param {string} props.title Page title
 * @param {string} props.description Page description text
 * @param {Array} props.features Array of feature objects to display as cards
 * @param {Function} props.onFeatureClick Function called when a feature is clicked
 * @param {Function} props.onBackClick Function called when back button is clicked
 * @param {string} props.backButtonTooltip Tooltip text for the back button
 * @returns {React.ReactElement} LandingPageLayout component
 */
const LandingPageLayout = ({ 
  title, 
  description, 
  features, 
  onFeatureClick,
  onBackClick,
  backButtonTooltip = 'Back',
  children 
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.landingDivContainer}>
        <div className={styles.buttonContainer}>
          <Tooltip title={backButtonTooltip}>
            <button 
              className={styles.backButton}
              onClick={onBackClick}
            >
              <ArrowBackIcon className={styles.backIcon} />
            </button>
          </Tooltip>
        </div>
        
        <div className={styles.landingContainer}>
          <h1 className={styles.landingTitle}>{title}</h1>
          <p className={styles.landingDescription}>
            {description}
          </p>
          
          <div className={styles.featureCardContainer}>
            {features.map((feature, index) => (
              <FeatureCard
                key={index}
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
                buttonText={feature.buttonText}
                onClick={() => onFeatureClick(feature.id)}
              />
            ))}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default LandingPageLayout;